import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

const inputCls =
  "w-full bg-[#141414] border border-white/10 px-5 py-4 text-sm text-[#F5F5F5] placeholder:text-zinc-600 focus:border-gold focus:outline-none transition-colors duration-300";

const fields = [
  ["name", "Recipient name", "sm:col-span-2"],
  ["phone", "Phone number", "sm:col-span-2"],
  ["line1", "Address line 1", "sm:col-span-2"],
  ["line2", "Address line 2 (optional)", "sm:col-span-2"],
  ["city", "City", ""],
  ["state", "State / Region", ""],
  ["zip", "Postal code", ""],
  ["country", "Country", ""],
];

export const AddressTab = () => {
  const { user, completeAuth } = useAuth();
  const [form, setForm] = useState({
    name: user.address?.name || user.name || "",
    phone: user.address?.phone || user.phone || "",
    line1: user.address?.line1 || "",
    line2: user.address?.line2 || "",
    city: user.address?.city || "",
    state: user.address?.state || "",
    zip: user.address?.zip || "",
    country: user.address?.country || "",
  });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.put("/account/address", form);
      completeAuth(data);
      toast.success("Address saved");
    } catch (err) {
      toast.error(formatApiError(err, "Could not save address"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="address-tab">
      <p className="text-sm text-zinc-500 max-w-lg leading-relaxed">
        Your delivery address is kept in the House ledger and pre-filled at checkout.
      </p>
      <form onSubmit={submit} className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl">
        {fields.map(([key, label, span]) => (
          <input
            key={key}
            data-testid={`address-${key}-input`}
            placeholder={label}
            value={form[key]}
            onChange={(e) => setForm({ ...form, [key]: e.target.value })}
            required={!["line2", "state", "phone", "name"].includes(key)}
            className={`${inputCls} ${span}`}
          />
        ))}
        <button
          data-testid="address-save-button"
          type="submit"
          disabled={saving}
          className="sm:col-span-2 mt-2 py-4 bg-maroon text-[#F5F5F5] text-xs tracking-[0.35em] uppercase font-semibold hover:bg-gold hover:text-black transition-colors duration-500 disabled:opacity-50"
        >
          {saving ? "..." : user.address ? "Update Address" : "Save Address"}
        </button>
      </form>
    </div>
  );
};
